import type { DataSequence } from "building-types/dataSequences/dataSequence";
import type { Doc } from "building-types/doc";
import type { DataSequenceHandle } from "building-types/handles/docEntityHandleTypes";
import { SystemDataSequences } from "../systemDataSequences";
import { docGetTableEntity } from "./docGetTableEntity";

export function docGetDataSequence(doc: Doc, handle: DataSequenceHandle): DataSequence | null {
  return SystemDataSequences[handle.id] ?? docGetTableEntity(doc, handle);
}
